// extracted by mini-css-extract-plugin
module.exports = {"container":"AllDone_container__1oesY","introText":"AllDone_introText__2RRA0","title":"AllDone_title__11myn"};